import React from 'react';
import {
    Checkbox,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    Slider,
    TextField,
    Typography,
    withStyles,
} from '@material-ui/core';
import { blockInvalidChar } from '../../../sc-utilities';
import { enabledField, valueText } from '../index';

const styles = (theme) => ({
    divider: {
        margin: theme.spacing(1),
    },
    formControl: {
        width: '100%',
    },
    smartScore: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    presetSmartScoreInput: {
        display: 'flex',
        alignItems: 'center',
    },
    presetSmartScore: {
        marginLeft: '10px',
    },
});

const PresetWorkSettings = (props) => {
    const {
        classes,
        translations,
        handleChange,
        values,
        setFieldValue,
        verify,
        methods,
        operatingSystems,
        setValues,
        valuesDiskHealth,
        skuPatterns,
        eraseOnly,
    } = props;

    const fieldNames = {
        AutoShutdown: `AutoShutdown`,
        automaticUnfreeze: `automaticUnfreeze`,
        MethodSSD: `MethodSSD`,
        VerificationSSD: `VerificationSSD`,
        CustomValueSSD: `CustomValueSSD`,
        MethodHDD: `MethodHDD`,
        VerificationHDD: `VerificationHDD`,
        CustomValueHDD: `CustomValueHDD`,
        UsePresetSmartScore: `UsePresetSmartScore`,
        PresetSmartScore: `PresetSmartScore`,
        OperatingSystemID: `OperatingSystemID`,
        NormalScreenBrightness: `NormalScreenBrightness`,
        ReducedScreenBrightness: `ReducedScreenBrightness`,
        SmartHealthCalculation: `SmartHealthCalculation`,
        SKUPatternID: `SKUPatternID`,
        PrintUponConnection: `PrintUponConnection`,
        PrintUponSuccessfulErasure: `PrintUponSuccessfulErasure`,
        PrintUponFailedOrAbortedErasure: `PrintUponFailedOrAbortedErasure`,
        PrintUponDiagnose: `PrintUponDiagnose`,
    };

    const fieldValues = {
        AutoShutdown: values['AutoShutdown'],
        automaticUnfreeze: values['automaticUnfreeze'],
        MethodSSD: values['MethodSSD'],
        VerificationSSD: values['VerificationSSD'],
        CustomValueSSD: values['CustomValueSSD'],
        MethodHDD: values['MethodHDD'],
        VerificationHDD: values['VerificationHDD'],
        CustomValueHDD: values['CustomValueHDD'],
        UsePresetSmartScore: values['UsePresetSmartScore'],
        PresetSmartScore: values['PresetSmartScore'],
        OperatingSystemID: values['OperatingSystemID'],
        NormalScreenBrightness: values['NormalScreenBrightness'],
        ReducedScreenBrightness: values['ReducedScreenBrightness'],
        SmartHealthCalculation: values['SmartHealthCalculation'],
        SKUPatternID: values['SKUPatternID'],
        PrintUponConnection: values['PrintUponConnection'],
        PrintUponSuccessfulErasure: values['PrintUponSuccessfulErasure'],
        PrintUponFailedOrAbortedErasure: values['PrintUponFailedOrAbortedErasure'],
        PrintUponDiagnose: values['PrintUponDiagnose'],
    };

    return (
        <>
            <Typography align="center" variant={'h5'}>
                {eraseOnly
                    ? translations['single_disk_drives_presets'] || 'Single disk-drives Presets'
                    : translations['work_presets'] || 'Work Presets'}
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoShutdown']}
                            checked={fieldValues['AutoShutdown'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['auto_shut_down'] || 'Auto shut down'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['automaticUnfreeze']}
                            checked={fieldValues['automaticUnfreeze'] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['automatic_unfreeze'] || 'Automatic unfreeze'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['PrintUponConnection']}
                            checked={fieldValues['PrintUponConnection'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['print_upon_connection'] || 'Print upon connection'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['PrintUponSuccessfulErasure']}
                            checked={fieldValues['PrintUponSuccessfulErasure'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['print_upon_successful_erasure'] || 'Print upon successful erasure'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['PrintUponFailedOrAbortedErasure']}
                            checked={fieldValues['PrintUponFailedOrAbortedErasure'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${
                        translations['print_upon_failed_or_aborted_erasure'] || 'Print upon failed or aborted erasure'
                    }`}
                />
            </FormGroup>
            {!eraseOnly && (
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={'dense'}
                                name={fieldNames['PrintUponDiagnose']}
                                checked={fieldValues['PrintUponDiagnose'] || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_diagnose'] || 'Print upon diagnose'}`}
                    />
                </FormGroup>
            )}
            <Divider className={classes.divider} variant="middle" />
            <Typography align="center" variant={'h5'}>
                {translations['erasure_ssd'] || 'Erasure SSD'}
            </Typography>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['wipe_method_ssd_text'] || 'Please select ssd erasure method'}
                </InputLabel>
                <Select
                    name={fieldNames['MethodSSD']}
                    label={translations['wipe_method_ssd'] || 'SSD Erasure method'}
                    margin={'dense'}
                    value={fieldValues['MethodSSD'] || ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(methods ? methods : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['wipe_verify_ssd_text'] || 'Please select ssd verify method'}
                </InputLabel>
                <Select
                    name={fieldNames['VerificationSSD']}
                    label={translations['VerificationSSD'] || 'Wipe verify ssd'}
                    margin={'dense'}
                    value={fieldValues['VerificationSSD'] || ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(verify ? verify : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {fieldValues['VerificationSSD'] === 'custom' ? (
                <>
                    <InputLabel shrink>
                        {translations['wipe_verify_ssd_number'] || 'Please select number of rounds for SSD'}
                    </InputLabel>
                    <Slider
                        name={fieldNames['CustomValueSSD']}
                        valueLabelFormat={valueText}
                        onChange={(event, value) => setFieldValue(fieldNames['CustomValueSSD'], value)}
                        valueLabelDisplay="on"
                        aria-labelledby="discrete-slider"
                        value={fieldValues['CustomValueSSD']}
                        step={1}
                        marks
                        min={0}
                        max={100}
                        disabled={enabledField(values)}
                    />{' '}
                </>
            ) : (
                <> </>
            )}
            <Divider className={classes.divider} variant="middle" />
            <Typography align="center" variant={'h5'}>
                {translations['erasure_hdd'] || 'Erasure HDD'}
            </Typography>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['wipe_method_hdd_text'] || 'Please select hdd erasure method'}
                </InputLabel>
                <Select
                    name={fieldNames['MethodHDD']}
                    label={translations['wipe_method_hdd'] || 'HDD Erasure method'}
                    margin={'dense'}
                    value={fieldValues['MethodHDD'] || ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(methods ? methods : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['wipe_verify_hdd_text'] || 'Please select hdd verify method'}
                </InputLabel>
                <Select
                    name={fieldNames['VerificationHDD']}
                    label={translations['VerificationHDD'] || 'Wipe verify hdd'}
                    margin={'dense'}
                    value={fieldValues['VerificationHDD'] || ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(verify ? verify : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {fieldValues['VerificationHDD'] === 'custom' ? (
                <>
                    <InputLabel shrink>
                        {translations['wipe_verify_hdd_number'] || 'Please select number of rounds for HDD'}
                    </InputLabel>
                    <Slider
                        name={fieldNames['CustomValueHDD']}
                        defaultValue={0}
                        valueLabelFormat={valueText}
                        onChange={(event, value) => setFieldValue(fieldNames['CustomValueHDD'], value)}
                        valueLabelDisplay="on"
                        aria-labelledby="discrete-slider"
                        value={fieldValues['CustomValueHDD']}
                        step={1}
                        marks
                        min={0}
                        max={100}
                        disabled={enabledField(values)}
                    />{' '}
                </>
            ) : (
                <> </>
            )}

            <FormGroup className={classes.smartScore}>
                <Checkbox
                    color={'primary'}
                    margin={'dense'}
                    name={fieldNames['UsePresetSmartScore']}
                    checked={!!fieldValues['UsePresetSmartScore'] || false}
                    onChange={(e) => {
                        if (!e.target.checked) {
                            setValues({ ...values, PresetSmartScore: null, UsePresetSmartScore: e.target.checked });
                        } else {
                            handleChange(e);
                        }
                    }}
                    disabled={enabledField(values)}
                />
                <Typography align="center" className={classes.presetSmartScoreInput} variant={'body2'}>
                    {translations['preset_smart_score'] || "Don't erase drives with worse SMART score than"}:
                </Typography>
                <TextField
                    name={fieldNames['PresetSmartScore']}
                    className={classes.presetSmartScore}
                    disabled={enabledField(values) || !fieldValues['UsePresetSmartScore']}
                    value={fieldValues['PresetSmartScore'] !== null ? fieldValues['PresetSmartScore'] : ''}
                    onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                            handleChange(e);
                        }
                    }}
                    type="number"
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0, max: 100 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onKeyDown={blockInvalidChar}
                />
            </FormGroup>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['disk_health_calculation'] || 'Disk Health Calculation'}</InputLabel>
                <Select
                    name={fieldNames['SmartHealthCalculation']}
                    label={translations['disk_health_calculation'] || 'Disk Health Calculation'}
                    margin={'dense'}
                    value={fieldValues['SmartHealthCalculation'] || 'securaze'}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {valuesDiskHealth.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Divider className={classes.divider} variant="middle" />
            <Typography align="center" variant={'h5'}>
                {translations['preset_advanced'] || 'Presets advanced'}
            </Typography>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['normal_screen_brightness'] ||
                        'Please choose normal screen brightness (e.g. after login, while entering data)'}
                </InputLabel>
                <br />
                <Slider
                    name={fieldNames['NormalScreenBrightness']}
                    value={fieldValues['NormalScreenBrightness']}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames['NormalScreenBrightness'], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={20}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['reduced_screen_brightness'] ||
                        'Please choose reduced screen brightness (e.g. during screensaver is visible)'}
                </InputLabel>
                <br />
                <Slider
                    name={fieldNames['ReducedScreenBrightness']}
                    value={fieldValues['ReducedScreenBrightness']}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames['ReducedScreenBrightness'], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={0}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['operating_system_text_select'] || 'Please select operating system'}
                </InputLabel>
                <Select
                    name={fieldNames['OperatingSystemID']}
                    label={translations['operating_system'] || 'Operating System'}
                    margin={'dense'}
                    value={fieldValues['OperatingSystemID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(operatingSystems ? operatingSystems : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['sku_select'] || 'Please select SKU pattern'}</InputLabel>
                <Select
                    name={fieldNames['SKUPatternID']}
                    value={fieldValues['SKUPatternID']}
                    label={translations['sku_pattern'] || 'SKU Pattern'}
                    margin={'dense'}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(skuPatterns ? skuPatterns : []).map((option) => (
                        <MenuItem key={option.SKUPatternID} value={option.SKUPatternID}>
                            {option.Name} - {option.Pattern}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};

export default withStyles(styles, { withTheme: true })(PresetWorkSettings);
